"use strict";
/*
 * ## External Dependencies ##
 *  - jQuery ($)
 *
 */

var Prompt = require("app/shared/components/Prompt/prompt");
var UserSelectorContainer = require("app/shared/components/UserSelector/user-selector-container");
var InputText = require("app/shared/components/InputText/input-text");
var Tooltip = require("app/shared/components/Tooltip/tooltip");
var Icon = require("app/shared/components/Icon/icon");
var _ = require("underscore");
var Intl = require("intl");

var AddTeamPrompt = React.createClass({
  mixins: [ReactIntl.IntlMixin],
  propTypes: {
    isOpen: React.PropTypes.bool.isRequired,
    onClose: React.PropTypes.func.isRequired,
    onConfirm: React.PropTypes.func.isRequired,
    handleOnChangeName: React.PropTypes.func.isRequired,
    handleLeaderSelection: React.PropTypes.func.isRequired,
    handleMemberSelection: React.PropTypes.func.isRequired,
    teamName: React.PropTypes.string.isRequired,
    leaderSelection: React.PropTypes.arrayOf(React.PropTypes.object),
    memberSelection: React.PropTypes.arrayOf(React.PropTypes.object),
  },
  disabledConfirmButton: function() {
    var isUserSelected = this.validateSelection();
    var teamNameLength = this.props.teamName ? this.props.teamName.length : 0;
    var hasTeamName = this.props.teamName || teamNameLength !== 0;

    return !(isUserSelected && hasTeamName);
  },
  validateSelection: function() {
    return !!_.findWhere(this.props.leaderSelection, {checked: true}) &&
      !!(_.findWhere(this.props.memberSelection, {checked: true}))
  },
  render: function(){
    var promptProps = {
      title:"Criação de uma nova Equipe",
      hideWarningIcon:false,
      buttonText:"Salvar",
      buttonClasses:"btn btn-primary"
    };

    if (!this.props.isOpen) {
      return (<div></div>);
    }
    return (
      <Prompt {...promptProps} {...this.props} disabledConfirmButton={this.disabledConfirmButton()} type="confirm">
        <div className="w-700">
          <PromptSubtitle text="Qual é o nome da equipe?" classNames="ta-c">
            <CreateTeamName teamName={this.props.teamName}
              handleOnChange={this.props.handleOnChangeName} />
          </PromptSubtitle>
          <div className="p-r">
            <PromptSubtitle text="Quem são os líderes?" helpText="Os líderes são usuários que têm acesso à carteira de cliente dos membros" classNames="ta-l d-ib f-l">
              <SelectTeamMember handleCustomSelection={this.props.handleLeaderSelection} users={this.props.leaderSelection} />
            </PromptSubtitle>
            <VerticalSeparator />
            <PromptSubtitle text="Quem são os membros?" helpText="Os membros são usuários que tem sua carteira de clientes compartilhada com os líderes e não têm acesso à carteira de outros membros" classNames="ta-l d-ib">
              <SelectTeamLeader handleCustomSelection={this.props.handleMemberSelection} users={this.props.memberSelection} />
            </PromptSubtitle>
          </div>
        </div>
      </Prompt>
    );
  }
});

const SelectTeamLeader = (props) => {
  var userSelectorContainerProps = {
    selectionType: "checkbox",
    color: "blue",
    border: "thick",
    className: "bg-none",
    handleCustomSelection: props.handleCustomSelection,
    forceState: true,
    users: props.users
  };

  return   <UserSelectorContainer {...userSelectorContainerProps} />;
};

const SelectTeamMember = (props) => {
  var userSelectorContainerProps = {
    selectionType: "checkbox",
    color: "blue",
    border: "thick",
    className: "bg-none",
    handleCustomSelection: props.handleCustomSelection,
    forceState: true,
    users: props.users
  };

  return <UserSelectorContainer {...userSelectorContainerProps} />;
};

const CreateTeamName = (props) => (
  <div className="mt-10 w-500 m-a">
    <InputText placeholder="Nome da Equipe"
        value={props.teamName}
        onChange={props.handleOnChange}
        maxLength={60} />
  </div>
);

const PromptSubtitle = (props) => (
  <div className={"mt-20 " + props.classNames}>
    <p className="prompt-text fs-18 d-ib">{props.text}</p><HelpTooltip text={props.helpText} />
    {props.children}
  </div>
);

const HelpTooltip = (props) => {
  if (props.text) {
    return <Tooltip title={props.text}>
      <Icon icon="info-sign" className="d-ib fs-14 ml-5" />
    </Tooltip>;
  }
  return <span />; // TODO React 15.0 allows return null
};

const VerticalSeparator = () => (
  <div style={{left: "50%", top: "20%", bottom: "5%"}} className="p-a b-light"></div>
);

module.exports = AddTeamPrompt;



// WEBPACK FOOTER //
// ./app/shared/components/TeamSelector/add-team-prompt.jsx